export interface IEntity {
  id: number;
  title: string;
  fields: IEntityField[];
}

export interface IEntityField {
  id: number;
  entityId: number;  
  title: string;
  fieldType: string;
}

export interface IFieldType {
  id: string;
  title: string;
}